import { OrderSignatureRequestSignature } from "./orderSignatureRequestSignature";

export interface OrderSignatureRequest {
  signature?: OrderSignatureRequestSignature;
  signedStatus?: OrderSignatureRequest.SignedStatusEnum;
  documentIds?: Array<string>;
}

export namespace OrderSignatureRequest {
  export type SignedStatusEnum =
    | "Yes"
    | "No"
    | "Rejected"
    | "e-Signed"
    | "Not Required";
  export const SignedStatusEnum = {
    Yes: "Yes" as SignedStatusEnum,
    No: "No" as SignedStatusEnum,
    Rejected: "Rejected" as SignedStatusEnum,
    ESigned: "e-Signed" as SignedStatusEnum,
    NotRequired: "Not Required" as SignedStatusEnum,
  };
}



// WEBPACK FOOTER //
// ./src/models/order-management/orderSignatureRequest.ts